"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomButtonGroup = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const styled_1 = require("./styled");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const helpers_1 = require("../helpers");
const useLabelTooltip_1 = require("../../useLabelTooltip");
const CustomButtonGroup = (field) => {
    var _a, _b, _c;
    const uiOptions = (_b = (_a = field.uiSchema) === null || _a === void 0 ? void 0 : _a['ui:options']) !== null && _b !== void 0 ? _b : {};
    const labelTooltip = (0, useLabelTooltip_1.useLabelTooltip)(uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.labelTooltip);
    const label = (0, helpers_1.getLabel)(field);
    const selected = (0, react_1.useMemo)(() => {
        var _a, _b;
        return (_b = (_a = field === null || field === void 0 ? void 0 : field.options) === null || _a === void 0 ? void 0 : _a.enumOptions) === null || _b === void 0 ? void 0 : _b.find(({ value }) => value === field.value || (typeof value === 'object' && (0, ramda_1.equals)(value, field.value)));
    }, [field.value, field === null || field === void 0 ? void 0 : field.options]);
    const Buttons = (_c = field.options.enumOptions) === null || _c === void 0 ? void 0 : _c.map((option) => {
        var _a, _b, _c;
        const handler = (opt) => {
            field.onChange(opt.value);
        };
        return (react_1.default.createElement(styled_1.StyledButton, Object.assign({}, uiOptions, { key: option.value, onClick: () => handler(option), StartIcon: ((_a = option.schema) === null || _a === void 0 ? void 0 : _a.icon) ? react_1.default.createElement(wl_ui_kit_1.Icon, { name: option.schema.icon }) : undefined, text: (_b = option.schema) === null || _b === void 0 ? void 0 : _b.title, value: option.value, disabled: field.disabled || ((_c = field.options.enumDisabled) === null || _c === void 0 ? void 0 : _c.includes(option.value)), variant: "outline", "$isSelected": (selected === null || selected === void 0 ? void 0 : selected.value) === option.value })));
    });
    return (react_1.default.createElement("div", null,
        !(0, ramda_1.isEmpty)(label) && react_1.default.createElement(wl_ui_kit_1.FormLabel, { labelTooltip: labelTooltip }, label),
        Buttons && react_1.default.createElement(styled_1.StyledGroup, null, Buttons)));
};
exports.CustomButtonGroup = CustomButtonGroup;
//# sourceMappingURL=custom-button-group.js.map